import { Spin } from "antd";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useVendorMasterStore } from "../../store/useVendorMasterStore";

const ApprovedStatusModal = ({ modalOpen, toggleModal, guid }) => {
  const { approvedStatus, loading } = useVendorMasterStore();

  const headerStyle = {
    padding: "12px",
    textAlign: "left",
    borderBottom: "2px solid #d9d9d9",
    fontWeight: "600",
    color: "#fbfafa",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  };

  return (
    <Modal isOpen={modalOpen} toggle={toggleModal} size="xl" centered>
      <ModalHeader toggle={toggleModal}>
        <div>Vendor application approve/reject status </div>
        {/* ({guid}) */}
        <div>
          {approvedStatus?.[0]?.VendorName} ({guid})
        </div>
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Spin size="large" />
          </div>
        ) : approvedStatus?.length > 0 ? (
          <div
            style={{ maxHeight: "500px", overflow: "auto", padding: "10px" }}
          >
            {Array.isArray(approvedStatus) ? (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#047470c1",
                      position: "sticky",
                      top: 0,
                      color: "#ffffff",
                    }}
                  >
                    <th style={headerStyle}>Serial No</th>
                    {/* <th style={headerStyle}>Vendor Name</th> */}
                    <th style={headerStyle}>Assign By</th>
                    <th style={headerStyle}>Assign To</th>
                    <th style={headerStyle}>Assign On</th>
                    <th style={headerStyle}>Application Status</th>
                    <th style={headerStyle}>Application Status On</th>
                    <th style={headerStyle}>Status Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {approvedStatus?.map((row, index) => (
                    <tr
                      key={index}
                      style={{ borderBottom: "1px solid #e8e8e8" }}
                    >
                      <td
                        style={{
                          padding: "12px",
                          color: "#666",
                        }}
                      >
                        {index + 1}
                      </td>
                      {/* <td
                        style={{
                          padding: "12px",
                          color: "#666",
                        }}
                      >
                        {row?.VendorName}
                      </td> */}
                      <td
                        style={{
                          padding: "12px",
                          color: "#666",
                        }}
                      >
                        {row?.AssignBy}
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          color: "#666",
                        }}
                      >
                        {row?.AssignTo}
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          color: "#666",
                        }}
                      >
                        {row?.AssignOn}
                      </td>
                      <td
                        style={{
                          padding: "12px",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            padding: "6px 14px",
                            borderRadius: "20px", // 🔥 round box
                            fontWeight: "600",
                            fontSize: "13px",
                            color: "#fff",
                            textAlign: "center",
                            minWidth: "90px",
                            backgroundColor:
                              row?.ApplicationStatus === "Rejected"
                                ? "#ef4444" // red
                                : row?.ApplicationStatus === "Approved"
                                  ? "#10b981" // green
                                  : row?.ApplicationStatus === "Pending"
                                    ? "#ff8514" // yellow
                                    : "#6c757d", // default grey
                          }}
                        >
                          {row?.ApplicationStatus}
                        </span>
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          color: "#666",
                        }}
                      >
                        {row?.ApplicationStatusOn}
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          color: "#666",
                        }}
                      >
                        {row?.StatusRemark}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div>No Record Found</div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ApprovedStatusModal;
